import { cx } from '@linaria/core';
import { RefObject, SyntheticEvent } from 'react';
import Button from '../Buttons/Button';
import Filter from '../Icons/Filter';
import "./ButtonFilter.linaria.module.css!=!./ButtonFilter?./ButtonFilter.linaria.module.css?css=H4sIAAAAAAAAA2XLSw6CMBRA0TmrcKiDkoAkYl1MU0p/UPpI+wJow96NI60Mb3JPyXFiQ8eqxd6kWNNkPVltj4Ze63l77EX5GUTLFGrr6rySAo8k2pek7Xd2wKpn04BTf5lm3vfWa4Iw0+YHyBzIA+gAEabMjLkZD8ZJhZlwuXAHEaw2GbkHY1ZWDZvv9HCKi04CHAS68HAmRIDHwCMSK8DHy2Mv3i5Nf0VNAQAA"
const filterStyles = "atm_jb_1vi7ecw atm_c8_ftgil2 atm_lo_1y44olf atm_le_1y44olf atm_lk_1y44olf atm_ll_1y44olf atm_9rhhw_1jxnbgj";
interface IButtonFilter {
  disabled?: boolean;
  className?: any;
  size?: number;
  isActive?: boolean;
  ref?: RefObject<HTMLElement>;
  showLabel?: boolean;
  title?: string;
  onClick?(event: SyntheticEvent, isActive?: boolean): void;
}
const ButtonFilter = ({
  disabled = false,
  isActive = false,
  ref,
  showLabel = false,
  size,
  className,
  title = null,
  onClick = () => {}
}: IButtonFilter) => {
  const label = showLabel ? <span>{title ?? 'Filter'}</span> : null;
  const handleOnClick = (event: SyntheticEvent) => {
    onClick?.(event, !isActive);
  };
  return <Button onClick={handleOnClick} disabled={disabled} title={title ?? 'Filter'} aria-label={title ?? 'Filter'} clean {...ref && {
    ref
  }} className={cx(filterStyles, className)}>
            <Filter size={size} />
            {label}
        </Button>;
};
export default ButtonFilter;